import { createSelector } from 'reselect';
import keyBy from 'lodash/keyBy';
import { getIOC } from './ioc';

export const getFoundTags = (state) => state?.tags?.foundTags;
export const getSearchQuery = (state) => state?.tags?.searchQuery;

export const selectIOCTagsObject = createSelector([getIOC], (ioc) => {
  return keyBy(ioc?.tags, 'id');
});

export const selectFoundTags = createSelector(
  [getFoundTags, getSearchQuery],
  (tags, searchQuery) => {
    const res = [];
    let alreadyExists = false;
    tags.forEach((tag) => {
      // FIXME: case-sensitive?
      if (tag?.name === searchQuery) alreadyExists = true;
      res.push({
        label: tag?.name,
        value: tag?.name,
        id: tag?.id,
      });
    });
    if (!alreadyExists && searchQuery) {
      res.push({
        isNew: true,
        label: searchQuery,
        value: searchQuery,
        id: undefined,
      });
    }
    return res;
  },
);
